
export default function EventBody({ description }){
    return(
        <div className="event-body">
            <p className="event-description">{ description.split('\n').map(line=> <> <br/> <span>{ line }</span> </>) }</p>
        </div>
    )
}